import React from 'react';
import { SectionTitle, ColorSwatch, SliderRow } from './ui-primitives';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
const FILL_TYPES = [
    { id: 'solid', label: 'Solid' },
    { id: 'linear', label: 'Linear' },
    { id: 'radial', label: 'Radial' },
    { id: 'conic', label: 'Conic' },
];
export function ColorsPanel({ settings, update }) {
    const isGradient = settings.fillType !== 'solid';
    return (<div className="space-y-4">
            <SectionTitle>Fill Type</SectionTitle>
            <ToggleGroup type="single" value={settings.fillType} onValueChange={(v) => v && update('fillType', v)} className="justify-start">
                {FILL_TYPES.map(({ id, label }) => (<ToggleGroupItem key={id} value={id} className="text-xs">
                        {label}
                    </ToggleGroupItem>))}
            </ToggleGroup>

            <div className="space-y-3">
                <SectionTitle>Dot Colors</SectionTitle>
                <ColorSwatch color={settings.c1} label={isGradient ? 'Color 1' : 'Color'} onChange={(v) => update('c1', v)}/>
                {isGradient && (<>
                        <ColorSwatch color={settings.c2} label="Color 2" onChange={(v) => update('c2', v)}/>
                        <SliderRow label="Gradient Angle" value={settings.gradAngle} min={0} max={360} step={1} onChange={(v) => update('gradAngle', v)} display={`${settings.gradAngle}°`}/>
                    </>)}
            </div>

            <div className="space-y-3">
                <SectionTitle>Eye Colors</SectionTitle>
                <ColorSwatch color={settings.eyeOut} label="Outer Ring" onChange={(v) => update('eyeOut', v)}/>
                <ColorSwatch color={settings.eyeIn} label="Inner Pupil" onChange={(v) => update('eyeIn', v)}/>
            </div>

            <div className="space-y-3">
                <SectionTitle>Background</SectionTitle>
                <ColorSwatch color={settings.bg} label="Background" onChange={(v) => update('bg', v)}/>
            </div>
        </div>);
}
